import { Form, InputNumber, InputNumberProps } from 'antd';
import { useField } from 'formik';
import { FormLabel } from './FormLabel';

interface Props extends InputNumberProps {
  fieldName: string;
  label?: string;
}

export const CurrencyInput = ({ fieldName, label, ...rest }: Props): JSX.Element => {
  const [{ value }, { touched, error }, { setValue, setTouched }] = useField<number>(fieldName);
  const [a, b, { setValue: setDiscountPercentage }] = useField<number>('discountPercentage');
  const [{ value: listPrice }, d, c] = useField<number>('listPrice');
  const [{ value: unitPrice }, e, f] = useField<number>('unitPrice');

  return (
    <Form.Item
      labelAlign="left"
      validateStatus={touched && error ? 'error' : 'success'}
      label={label ? <FormLabel label={label} /> : undefined}
      help={touched && error ? error : undefined}
      style={{ marginBottom: 0 }}
      labelCol={{ style: { padding: 0 } }}>
      <InputNumber
        {...rest}
        formatter={(value: string | number | undefined): string => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        parser={(value: string | undefined): string => value!.replace(/\$\s?|(,*)/g, '')}
        value={value || undefined}
        onChange={(value): void => {
          if (fieldName === 'unitPrice') {
            if (!value) {
              setDiscountPercentage(0);

              return;
            }
            setDiscountPercentage(listPrice ? Math.ceil(100 - ((value as number) / listPrice) * 100) : 0);
          }
          // if (fieldName === 'listPrice') {
          //   setDiscountPercentage(value ? Math.ceil(100 - ((unitPrice as number) / (value as number)) * 100) : 0);
          // }

          setValue(Number(value));
        }}
        onFocus={(): void => setTouched(false)}
        onBlur={(): void => setTouched(true)}
        style={{ borderRadius: 5, width: '100%' }}
        controls={false}
      />
    </Form.Item>
  );
};
